<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				border
				stripe
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				@row-dblclick='rowClick'
				@sort-change='sortChangeHandle'
			>
				<el-table-column
					prop="name"
					label="员工姓名"
					min-width="100"
					align="center">
				</el-table-column>
				<el-table-column
					prop="commissionrules"
					label="返佣方式"
					align="center"
					width="300">
					<template slot-scope="scope">
						混合：{{scope.row.commissionType === '1' ? `百分比（${$fxUtils.toFixedSHW(scope.row.commissionValue, 2)}%）` : `固定金额（￥${$fxUtils.toFixedSHW(scope.row.commissionValue, 2)}）`}}
					</template>
				</el-table-column>
				<el-table-column
					prop="returnmoney"
					label="不可提现金额"
					sortable="custom"
					min-width="190"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.returnmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="uncashoutmoney"
					label="可提现金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.uncashoutmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="unreviewmoney"
					label="待审核金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.unreviewmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="reviewmoney"
					label="已审核金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.reviewmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashoutmoney"
					min-width="180"
					label="已提现金额"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.cashoutmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cycleday"
					label="到账周期"
					min-width="150"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>T+{{scope.row.cycleday ? scope.row.cycleday : '0'}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="200" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" v-if="AuthorityList['11_0003_0001_00'] && AuthorityList['11_0003_0002_00'] && AuthorityList['11_0003_0003_00']" @click="getDetail(scope.row)">明细</el-button>
						<!-- <el-button type='text' size="mini" v-if="AuthorityList['11_0003_0003_00']" @click="apply(scope.row)">提现申请</el-button> -->
						<el-button type='text' size="mini" v-if="AuthorityList['11_0003_0003_00']" @click="openApplyDialog(scope.row)">提现申请</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="600px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div>您确认要进行提现吗？</div>
				<div style="font-size: 18px;">可提现金额：￥{{uncashoutmoney}}</div>
				<div>注：如提现申请被拒绝后，系统自动返还可提现金额，需再次进行提现操作！</div>
				<div class="btn-box" style="padding-top: 25px;text-align: center;">
					<el-button class="btn" size="small" plain type="primary" @click="close">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="apply">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		dateValue: {
			type: Array
		}
		// needauditingflag: Boolean,
		// canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			uncashoutmoney: '',
			dialogVisible: false,
			rowsData: {}
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	methods: {
		rowClick (row, column, event) {
			if (this.AuthorityList['11_0003_0001_00'] || this.AuthorityList['11_0003_0002_00'] || this.AuthorityList['11_0003_0003_00']) {
				this.getDetail(row)
			}
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.orderid
			})
			this.$emit('selectIds', ids)
		},
		sortChangeHandle (data) {
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		getDetail (value) {
			this.$router.push({ path: '/main/rebateStatisticsDetail', query: { staff: value.name, dateValue: this.dateValue } })
		},
		openApplyDialog (row) {
			this.uncashoutmoney = row.uncashoutmoney
			this.rowsData = row
			this.dialogVisible = true
		},
		close () {
			this.dialogVisible = false
		},
		apply () {
			let row = this.rowsData
			let params = {
				staffId: row.staffid,
				applyMoney: row.uncashoutmoney,
				commissionType: row.commissionType,
				commissionValue: row.commissionValue,
				cycleday: row.cycleday
			}
			let text = `员工名称【${row.name}】进行提现申请，提现金额【￥${row.uncashoutmoney}】`
			// let text = `员工名称【${row.staff}】提现编号【${row.cashoutcode}】提现金额【￥${row.cashoutmoney}】审核【${num === 2 ? '同意' : '拒绝'}】`
			let changeData = {
				pre: { rebateData: {} },
				cur: { rebateData: { text: text } }
			}
			const logger = this.$fxLogger.createInfo('results.rebateStatistics.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/return/cashoutapply`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.dialogVisible = false
					this.$parent.findOrderList()
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
		line-height: 40px;
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
}
</style>
